/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { Link } from 'react-router-dom';

import { withStyles } from '@material-ui/core/styles';
import {
    object, arrayOf, shape, string,
} from 'prop-types';
import GraphqlBreadcrumbSeoSchema from './Partials/GraphqlBreadcrumbSeoSchema';
import { transformCharacters } from '../../../../helpers/markdown/characterTransformer';
import { sanitizeContent } from '../../../../../lib/sanitize';

const styles = (theme) => ({
    breadCrumb: {
        listStyle: 'none',
        fontSize: '14px',
        display: 'inline-flex',
        alignItems: 'baseline',
        margin: 0,
        padding: 0,
        flexWrap: 'wrap',
        [theme.breakpoints.down(400)]: {
            textAlign: 'center',
            fontSize: '13px',
            lineHeight: '1.5',
        },
    },
    breadCrumbListItem: {
        marginRight: '5px',
        '&:last-child': {
            color: '#757575',
            whiteSpace: 'nowrap',
        },
        '&::after': {
            content: '"»"',
            position: 'relative',
            right: '0',
        },
        '&:last-child::after': {
            content: '""',
            display: 'none',
        },
        '& a': {
            textDecoration: 'none',
            paddingRight: '5px',
            whiteSpace: 'nowrap',
            color: theme.palette.cms?.primary || theme.palette.colorPrimary,
            '&:hover, &:focus': {
                textDecoration: 'underline',
            },
        },
    },
});

function GraphqlBreadcrumbs({ classes, breadCrumbArray }) {
    return (
        <>
            <GraphqlBreadcrumbSeoSchema breadCrumbArray={breadCrumbArray} />
            <ol className={classes.breadCrumb} aria-label="hidden" tabIndex="-1">
                { breadCrumbArray && breadCrumbArray.length > 0 ? breadCrumbArray.map((d, i) => (
                // if last element remove <Link>
                    i === breadCrumbArray.length - 1
                        ? (
                            <li key={d.title} className={classes.breadCrumbListItem} aria-hidden="false">
                                {transformCharacters(sanitizeContent(d.title))}
                            </li>
                        )
                        : (
                            <li key={d.title} className={classes.breadCrumbListItem}>
                                <Link tabindex="-1" to={d.href} aria-hidden="true">
                                    {transformCharacters(sanitizeContent(d.title))}
                                </Link>
                            </li>
                        )
                )) : (
                    // default if no breadcrumb data
                    <li className={classes.breadCrumbListItem}>
                        <Link to="/">
                            <span role="img" aria-label="Home icon">🏠</span> Home
                        </Link>
                    </li>
                ) }
            </ol>
        </>
    );
}

GraphqlBreadcrumbs.propTypes = {
    classes: object.isRequired,
    breadCrumbArray: arrayOf(
        shape({
            title: string.isRequired,
            href: string.isRequired,
        }),
    ).isRequired,
};

export default withStyles(styles)(GraphqlBreadcrumbs);
